
import FeaturedInfo from "../../components/featuredInfo/FeaturedInfo";
import "./home.css";

import WidgetSm from "../../components/widgetSm/WidgetSm";
import WidgetLg from "../../components/widgetLg/WidgetLg";
import { mobile } from '../../responsive';

export default function Home() {
  
  return (
    <div className="home">
      <FeaturedInfo />
      {/* <Chart data={userStats} title="User Analytics" grid dataKey="Active User"/> */}
      <div className="homeWidgets">
        <WidgetSm/>
        <WidgetLg/>
      </div>
    </div>
  );
}
